import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "80",
  height: "80",
  viewBox: "0 0 57 53"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<defs><filter id=\"a\" width=\"57\" height=\"53\" x=\"0\" y=\"0\" filterUnits=\"userSpaceOnUse\"><feOffset dy=\"3\"></feOffset><feGaussianBlur result=\"blur\" stdDeviation=\"3\"></feGaussianBlur><feFlood flood-opacity=\".161\"></feFlood><feComposite in2=\"blur\" operator=\"in\"></feComposite><feComposite in=\"SourceGraphic\"></feComposite></filter></defs><g filter=\"url(#a)\"><rect width=\"39\" height=\"35\" fill=\"#3C3D40\" rx=\"6\" transform=\"rotate(180 24 20.5)\"></rect></g><path fill=\"#fff\" d=\"m34.874 17.964-.84-.842-5.534 5.534-5.534-5.534-.842.842 5.534 5.534-5.534 5.534.842.842L28.5 24.34l5.534 5.532.842-.842-5.534-5.534z\"></path>", 3)
const _hoisted_5 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render };